import { createHttpLink } from '@apollo/client';
import { GRAPHQL_URL } from './types';

export const httpLink = createHttpLink({
  uri: GRAPHQL_URL,
  credentials: 'include',
});
